/**
 * These map to components with prefix "cohorts-builder-", ie, for BuilderType.Date
 * there is a corresponding "cohorts-builder-time"
 */
export enum BuilderType {
  ClauseOperator = `clause-operator`,
  Condition = `condition`,
  Date = `time`,
  DistinctDay = `distinct-day`,
  Frequency = `frequency`,
  PropertyFilter = `property-filter`,
}

export enum ConditionType {
  Cohorts = `cohorts`,
  Events = `events`,
  People = `users`,
}

export enum ConditionTab {
  All = `all`,
  Cohorts = `cohorts`,
  DataGroup = `datagroup`,
  Events = `events`,
  People = `users`,
}

export enum PropertyTab {
  All = `all`,
  DataGroup = `datagroup`,
  Events = `events`,
  People = `users`,
}

export enum DateRangeType {
  Between = `between`,
  On = `on`,
  Relative = `in the last`,
  Since = `since`,
  RelativeFuture = `in the next`,
  RelativeBeforeInPast = `more than`,
}

export enum Type {
  Boolean = `boolean`,
  Datetime = `datetime`,
  List = `list`,
  Number = `number`,
  String = `string`,
  Dimension = `dimension`,
}

export enum StringOperator {
  Contains = `contains`,
  DoesNotContain = `does not contain`,
  DoesNotEqual = `does not equal`,
  Equals = `equals`,
  NotSet = `is not set`,
  Set = `is set`,
}

export enum NumberOperator {
  AtLeast = `is at least`,
  Between = `is between`,
  EqualTo = `is equal to`,
  NotEqualTo = `is not equal to`,
  GreaterThan = `is greater than`,
  LessThan = `is less than`,
}

export enum DatetimeOperator {
  After = `was after`,
  Between = `was between`,
  On = `was on`,
  Relative = `was in the last`,
  RelativeFuture = `is in the next`,
  RelativeBeforeInPast = `was more than`,
}

export enum ListOperator {
  Contains = `contains`,
  DoesNotContain = `does not contain`,
}

export enum BooleanOperator {
  True = `true`,
  False = `false`,
}

export enum FrequencyOperator {
  AtLeast = `at least`,
  Between = `between`,
  EqualTo = `equal to`,
  GreaterThan = `greater than`,
  LessThan = `less than`,
}
